import React, { useEffect, useRef } from "react";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Bold, Italic, Underline, List, ListOrdered, Heading2, AlignLeft, AlignCenter, AlignJustify, Minus } from "lucide-react";

export const PLACEHOLDERS = ["ragione_sociale", "nome", "piva", "codice_fiscale", "indirizzo", "cap", "citta", "provincia",
  "email", "codice_sdi", "entita", "data", "anno"];

export const RichTextEditor = ({ value, onChange, placeholderLabel }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) ref.current.innerHTML = value || "";
  }, [value]);

  const cmd = (c, arg) => {
    ref.current?.focus();
    document.execCommand(c, false, arg);
    onChange(ref.current?.innerHTML || "");
  };
  const tools = [
    ["bold", Bold], ["italic", Italic], ["underline", Underline],
    ["insertUnorderedList", List], ["insertOrderedList", ListOrdered],
    ["justifyLeft", AlignLeft], ["justifyCenter", AlignCenter], ["justifyFull", AlignJustify],
  ];

  return (
    <div className="rounded-md border border-input bg-background" data-testid="rich-text-editor">
      <div className="flex flex-wrap items-center gap-1 border-b border-border p-1.5">
        {tools.map(([c, Icon]) => (
          <Button key={c} type="button" size="icon" variant="ghost" className="h-7 w-7" onMouseDown={(e) => { e.preventDefault(); cmd(c); }} data-testid={`rte-${c}`}>
            <Icon className="h-3.5 w-3.5" />
          </Button>
        ))}
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onMouseDown={(e) => { e.preventDefault(); cmd("formatBlock", "<h2>"); }} data-testid="rte-heading">
          <Heading2 className="h-3.5 w-3.5" />
        </Button>
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onMouseDown={(e) => { e.preventDefault(); cmd("insertHorizontalRule"); }} data-testid="rte-hr">
          <Minus className="h-3.5 w-3.5" />
        </Button>
        <div className="ml-auto w-52">
          <Select value="" onValueChange={(v) => cmd("insertText", `{{${v}}}`)}>
            <SelectTrigger className="h-7 text-xs" data-testid="rte-placeholder-select"><SelectValue placeholder={placeholderLabel} /></SelectTrigger>
            <SelectContent>
              {PLACEHOLDERS.map((p) => <SelectItem key={p} value={p} className="font-mono text-xs" data-testid={`rte-ph-${p}`}>{`{{${p}}}`}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning
        className="prose prose-sm max-w-none min-h-[280px] p-4 text-sm outline-none [&_h2]:text-lg [&_h2]:font-bold [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6"
        onInput={() => onChange(ref.current?.innerHTML || "")} data-testid="rte-content" />
    </div>
  );
};
